import { fontStyles } from '../../assets/fonts/font';
import colorConfigs from '../../configs/colorConfigs';

const HeaderStyles = {
  appBar: {
    backgroundColor: colorConfigs.secondary,
    boxShadow: 'none',
    top: 0,
    width: '100%',
    borderBottom: `3px solid ${colorConfigs.black}`,
  },
  submenu: {
    backgroundColor: colorConfigs.primary,
    boxShadow: 'none',
    top: 0,
    width: '100%',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
  flex40: {
    flex: '0 0 40%',
  },
  flex20: {
    flex: '0 0 20%',
    justifyContent: 'center',
  },
  flexEnd: {
    justifyContent: 'flex-end',
  },
  button: {
    textTransform:"none",
    color: fontStyles.textColor,
    fontSize: fontStyles.fontSizeLarge,
    fontWeight: fontStyles.fontWeightBold,
    fontFamily: fontStyles.primaryFont,
    borderRadius: '0px',
    position: 'relative',
    paddingBottom: '10px',
    '&:hover': {
      borderRadius: '0px',
      backgroundColor: colorConfigs.transparent,
      '& svg': {
        opacity: 1,
        transform: 'scaleX(1)', 
      },
    },
    '& >svg': {
      position: 'absolute',
      width: '100%',
      opacity: 0,
      transform: 'scaleX(0)',
      transition: 'opacity 0.3s ease, transform 0.3s ease',
    },
  },
  logoButton: {
    padding: 0,
  },
  BannerButton: {
    color: colorConfigs.tertiary,
    background: colorConfigs.secondary,
    borderRadius: '30px',
    fontSize: fontStyles.fontSizeMedium,
    fontWeight: fontStyles.fontWeightBold,
    fontFamily: fontStyles.primaryFont,
    '&:hover': {
      backgroundColor: colorConfigs.secondary,
      color: colorConfigs.tertiary,
    },
    textTransform: 'none',
  },
  logo: {
    height: '30px',
    maxWidth: '100%',
  },
  getActiveButtonStyle: (isActive: boolean) => ({
    position: "relative",
    '& svg': {
      position: "absolute",
      width: "100%",
      opacity: isActive ? 1 : 0,
      transform: isActive ? "scaleX(1)" : "scaleX(0)",
      transition: "opacity 0.3s ease, transform 0.3s ease",
    },
  }),
};

export default HeaderStyles;
